import { FieldArray } from 'react-final-form-arrays';
import { FormSpy, useField } from 'react-final-form';

import { REQUIREMENTS_BLOCK_ID } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { ErknmFillInProcessMessage } from 'KnmErknmPackage/MainModule/components/ErknmFillInProcessMessage';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { ErknmApproveRemarkSectionCodeEnum } from 'KnmErknmPackage/ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';
import { IKnmErknmFormViolatedRequirementsMandatory } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { ErknmFieldMark } from 'KnmErknmPackage/MainModule/components/ErknmFieldMark';
import { ErknmApproveRemark } from 'KnmErknmPackage/ErknmApproveRemarkModule/components/ErknmApproveRemark';
import { IKnmErknmFormRequirementNpa } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormRequirementNpa';
import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { Hint } from 'CorePackage/MainModule/components/Hint';
import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';
import { IKnmLink } from 'APIPackage/KnmModule/interfaces/IKnmLink';

import styles from './ErknmRepeatViolation.module.scss';
import { ViolationItem } from './ViolationItem';

interface IErknmRepeatViolationProps {
  checkboxDisabled: boolean;
}

export const ErknmRepeatViolation = ({ checkboxDisabled }: IErknmRepeatViolationProps) => {
  const requirementsNpaFieldName = 'requirementsNpaErknm' as keyof IKnmForm;

  const reasonLinks = useField<IKnmLink[]>('reasonsErknm[0].links')?.input?.value;

  const targetErpId =
    reasonLinks && Array.isArray(reasonLinks) && reasonLinks.length > 0 ? reasonLinks[0]?.erpId : undefined;

  return (
    <>
      <FieldBlock
        label={
          <>
            Нарушения, подлежащие проверке
            <ErknmFieldMark fieldName={requirementsNpaFieldName} />
          </>
        }
        id={REQUIREMENTS_BLOCK_ID}
        fillInProcess={<ErknmFillInProcessMessage name="requirementsErknm" />}
      >
        <Hint
          text="В предмет добавляются нарушения, срок исполнения которых истек относительно даты начала мероприятия"
          margin="bottom"
        />
        <ErknmApproveRemark sectionCode={ErknmApproveRemarkSectionCodeEnum.REQUIREMENTS} />
        <FormSpy subscription={{ errors: true, touched: true }}>
          {() => (
            <div className={styles.ErknmRepeatViolationNpaWrapper}>
              <FieldArray name={requirementsNpaFieldName}>
                {({ fields }) => {
                  return fields.map((name, index) => {
                    const requirementNpa: IKnmErknmFormRequirementNpa = fields.value?.[index];
                    const { npa, structuralUnit } = requirementNpa;

                    if (!npa || !structuralUnit) return null;

                    return (
                      <FieldArray key={name} name={`${name}.mandatory`}>
                        {({ fields: mFields }) =>
                          mFields.map((mName, mIndex) => {
                            const mandatory = mFields.value?.[mIndex] as IKnmErknmFormViolatedRequirementsMandatory;

                            if (!mandatory || !mandatory.mandatory) return null;

                            return (
                              <FieldArray key={name} name={`${mName}.violations`}>
                                {({ fields: vFields }) =>
                                  vFields.map((vName, vIndex) => {
                                    const violation = vFields.value?.[vIndex] as IKnmErknmFormViolation;

                                    if (!violation) return null;

                                    return (
                                      <ViolationItem
                                        key={`${vName}-${violation.id}`}
                                        violation={violation}
                                        requirementNpa={requirementNpa}
                                        mandatory={mandatory}
                                        violationName={vName}
                                        checkboxDisabled={
                                          checkboxDisabled || violation.status === ViolationStatusesEnum.FIXED
                                        }
                                        targetErpId={targetErpId}
                                      />
                                    );
                                  })
                                }
                              </FieldArray>
                            );
                          })
                        }
                      </FieldArray>
                    );
                  });
                }}
              </FieldArray>
            </div>
          )}
        </FormSpy>
      </FieldBlock>
    </>
  );
};
